import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useService } from '../providers/ServiceProvider';

export function useAssetListQuery(projectId: string, queryParams?: { limit?: number; offset?: number }) {
  const client = useService();
  return useQuery<any[], Error>(
    ['asset-list', projectId, queryParams],
    () => client.assetList(projectId, queryParams),
    {
      keepPreviousData: true
    }
  );
}

export function useAssetReadQuery(projectId: string, assetId: string) {
  const client = useService();
  return useQuery<any, Error>({
    queryKey: ['asset-read', projectId, assetId],
    queryFn: () => client.assetRead(projectId, assetId)
  });
}

export function useAssetDestroyMutation() {
  const client = useService();
  const queryClient = useQueryClient();
  return useMutation(
    (data: { projectId: string; assetId: string }) => client.assetDestroy(data.projectId, data.assetId),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(['asset-list']);
      }
    }
  );
}
